import { DescriptionPage_UpsellType as UpsellType } from '__generated__/graphql-types';

import { getUpsellCopy } from 'bundles/stackability-common';
import type { DegreeFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

const buildTowardADegreeTypes = [UpsellType.PartOf, UpsellType.OffersCredit];

const getUpsellCaption = (degrees: Array<DegreeFragment>): string => {
  // Use the first upsell when there are multiple
  const upsellType = degrees[0]?.upsellType;
  const upsellCopy = getUpsellCopy().homepagesNavXdp;
  return buildTowardADegreeTypes.includes(upsellType ?? '')
    ? upsellCopy.buildTowardADegree
    : upsellCopy.prepareForADegree;
};

export default getUpsellCaption;
